import { logout } from '@/utils/auth';
import { putJson } from '@/utils/fetchOptions';

import { message } from 'antd/lib';
import { useTranslation } from 'react-i18next';
import { useAuthToken, useMutation } from '..';

interface UsePublicationReportProps {
  id: string;
  onSuccess?: TypeAny;
  permalink: string;
  sparkId: string;
}
export interface PublicationReportResponse {
  code: string;
  publication: Api.Influencer.Publication;
}

export function usePublicationReport({
  id,
  onSuccess,
  permalink,
  sparkId
}: UsePublicationReportProps) {
  const token = useAuthToken();
  const { t } = useTranslation();

  const {
    mutate: mutation,
    error,
    isLoading
  } = useMutation({
    mutationKey: 'influencer-publication-report',
    mutationFn: async () =>
      putJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/publication/${id}/report`,
        body: {
          permalink,
          spark_id: sparkId
        },
        token
      }).then((response: PublicationReportResponse | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          message.success(t(`alert.${response.code}`));
        }

        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutation,
    error
  };
}
